import { X, Paperclip, FileSpreadsheet, FileText, Presentation, Table2 } from 'lucide-react';
import { getAttachmentFileIcon } from '@/lib/llm-chat-attachment-file-types';

interface LlmChatAttachmentChipProps {
  name: string;
  size: number;
  onRemove: () => void;
}

function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function AttachmentIcon({ name }: { name: string }) {
  const kind = getAttachmentFileIcon(name);
  if (kind === 'numbers' || kind === 'sheet') {
    return <FileSpreadsheet className="h-3.5 w-3.5 text-muted-foreground" />;
  }
  if (kind === 'pages' || kind === 'doc') {
    return <FileText className="h-3.5 w-3.5 text-muted-foreground" />;
  }
  if (kind === 'slides') {
    return <Presentation className="h-3.5 w-3.5 text-muted-foreground" />;
  }
  if (kind === 'csv') return <Table2 className="h-3.5 w-3.5 text-muted-foreground" />;
  return <Paperclip className="h-3.5 w-3.5 text-muted-foreground" />;
}

export function LlmChatAttachmentChip({ name, size, onRemove }: LlmChatAttachmentChipProps) {
  return (
    <div className="flex items-center gap-2 rounded-md border bg-muted/50 px-2.5 py-1.5 text-xs">
      <AttachmentIcon name={name} />
      <span className="max-w-[120px] truncate font-medium">{name}</span>
      <span className="text-muted-foreground">{formatFileSize(size)}</span>
      <button onClick={onRemove} className="ml-1 rounded-sm hover:bg-muted">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
